import { AController } from "@eagerlogic/react-mvc";
import { ApiException } from "rpc/rpc";
import { AuthRpc } from "rpc/auth/AuthRpc";
import { Navigation } from "utils/Navigation";
import { ResetPasswordModel } from "../model/ResetPasswordModel";

export class ResetPasswordController extends AController<ResetPasswordModel> {

    protected createInitialModel(): ResetPasswordModel {
        var model = new ResetPasswordModel();
        model.isInit = true;

        AuthRpc.passwordResetInfo(this.getToken()).then((res) => {
            this.model.isInit = false;
            this.model.valid = res.valid;
            if (!res.valid) {
                this.model.globalError = res.error;
            }
            this.render(this.model);
        }).catch((ex: ApiException) => {
            this.model.isInit = false;
            this.model.valid = false;
            this.model.globalError = ex.message != null ? ex.message : "This password reset link is invalid or has expired.";
            this.render(this.model);
        });

        return model;
    }

    public onSubmitClicked(password: string) {
        this.model.password = password;
        this.model.passwordError = null;
        this.model.globalError = null;

        // Same rule as registration (see backend Validators.passwordValidator).
        var trimmed = password == null ? "" : password.trim();
        if (trimmed.length < 6 || trimmed.length > 64) {
            this.model.passwordError = "Minimum 6 maximum 64 characters!";
            this.render(this.model);
            return;
        }

        this.render(this.model);

        AuthRpc.resetPassword({ token: this.getToken(), password: password }).then(() => {
            // Password changed — send the user to the login page.
            Navigation.pushState(null, "/login.rsc");
        }).catch((ex: ApiException) => {
            var fieldError = ex != null && ex.fieldErrors != null ? ex.fieldErrors["password"] : null;
            if (fieldError != null) {
                this.model.passwordError = fieldError;
            } else {
                this.model.globalError = ex.message != null ? ex.message : "This password reset link is invalid or has expired.";
            }
            this.render(this.model);
        });
    }

    private getToken(): string {
        var token = Navigation.currentState.params["token"];
        return token == null ? "" : token;
    }

}
